import { normalizeFields } from "@/forms/helpers";

export const model = normalizeFields({
  message: {
    type: "text",
    label: "contact_page.message",
    value: "",
    required: true,
    min: 6,
  },
});
